import { Grid } from '@bigcommerce/big-design';
import Export from './components/Export';
import Import from './components/Import';

export function FitmentPage() {
	return (
		<Grid
			gridColumns="repeat(auto-fit, minmax(700px, 1fr))"
			style={{ maxWidth: '1600px', width: '100%', margin: '0 auto' }}
		>
			<Export />
			<Import />
		</Grid>
	);
}
